import React from 'react';

const EsporaiInput = ({ 
  value, 
  onChange, 
  className,
  divClassName,
  disabled, 
  placeholder, 
  type = 'text',
  label,
  error,
  ...props 
}) => {
  const baseClasses = 'w-full px-4 py-3 bg-white border rounded-xl focus:outline-none transition-colors duration-200';
  const stateClasses = {
      normal: 'border-gray-light text-gray-dark placeholder-gray focus:border-gray',
      error: 'border-error text-gray-dark placeholder-gray focus:border-error',
      disabled: 'opacity-60 bg-gray-light cursor-not-allowed',
  };
  
  const getStateClass = () => {
    if (disabled) return stateClasses.disabled;
    if (error) return stateClasses.error;
    return stateClasses.normal;
  };

  const handleChange = (e) => {
    if (onChange) onChange(e.target.value, e);
  };

  return (
    <div className={`w-full ${divClassName}`}>
      {label && (
        <label className="block text-gray-dark mb-2 font-medium">
          {label}
        </label>
      )}
      <input
        type={type}
        value={value}
        onChange={handleChange}
        disabled={disabled}
        placeholder={placeholder}
        className={`${baseClasses} ${getStateClass()} ${className}`}
        {...props}
      />
      <div className="h-5 mt-2">
        {error && typeof error === 'string' && (
          <p className="text-sm text-error">{error}</p>
        )}
      </div>
    </div>
  );
};

export default EsporaiInput;